import { useEffect, useMemo, useState } from 'react';
import { useQueryParams } from '@/hooks';
import { parseParamsFromParams } from '@/utils';

export interface RequestsFilter {
  userId?: string[];
  statuses?: string[];
  assetTypeId?: string[];
}

const useRequestsFilter = () => {
  const { getQueryParam, setQueryParams } = useQueryParams();

  const initialFilter: RequestsFilter = useMemo(
    () => ({
      userId: [],
      statuses: [],
      assetTypeId: [],
    }),
    []
  );

  const [filter, setFilter] = useState<RequestsFilter>(() => {
    const userIdParam = getQueryParam('userId') || '';
    const statusesParam = getQueryParam('statuses') || '';
    const assetTypeIdParam = getQueryParam('assetTypeId') || '';

    return {
      userId: parseParamsFromParams(userIdParam) || initialFilter.userId,
      statuses: parseParamsFromParams(statusesParam) || [],
      assetTypeId: parseParamsFromParams(assetTypeIdParam) || [],
    };
  });

  useEffect(() => {
    setQueryParams({
      userId: filter.userId?.toString(),
      statuses: filter.statuses?.toString(),
      assetTypeId: filter.assetTypeId?.toString(),
    });
  }, [filter]);

  return { filter, initialFilter, setFilter };
};

export default useRequestsFilter;
